import { render } from "./DropdownInput.vue?vue&type=template&id=799f8b14"
import script from "./DropdownInput.vue?vue&type=script&lang=js"
export * from "./DropdownInput.vue?vue&type=script&lang=js"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__